import { useQuery } from '@tanstack/react-query'
import { useMergeFields } from '@web/components/page-components/Text/MergeTags/MergeTag'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { toSearchParams } from 'apps/fe-donation/utils'
import { useEffect } from 'react'

const CampaignAmountRaisedHandler = () => {
  const shouldProcess = useMergeFields((state) => state.postProcessTags.has('Campaign.AmountRaised'))
  const campaignId = usePageStore((state) => state.campaignId)
  const isLiveMode = usePageStore((state) => state.isLiveMode)

  const { data: amount = 0 } = useQuery({
    queryKey: ['campaignAmount', campaignId],
    queryFn: async () => {
      const amount = await fetch(
        `/api/progress-bar?${toSearchParams({
          campaignId,
          isAllPagesLinked: true,
          isLiveMode,
        })}`,
      )
        .then((res) => res.json())
        .then((data) => data.amount)
        .catch(() => 0)
      return amount
    },
    refetchOnMount: false,
    enabled: !!campaignId && shouldProcess,
  })

  useEffect(() => {
    if (!shouldProcess || !amount) {
      return
    }

    useMergeFields.getState().setMergeField('Campaign.AmountRaised', amount.toString())
  }, [amount, shouldProcess])

  return null
}

export default CampaignAmountRaisedHandler
